// generated from 126_551 samples

import { z } from "zod";
import { common } from "../common";
import { stepGetBaseSchema } from "./stepGetBaseSchema";

export const experimentStepGetSchema = z.object({
  ...stepGetBaseSchema.shape,
  type: z.literal("EXPERIMENT"),
  step_data: z.object({
    // avg: 2243004.11, min: 86400, max: 2592000
    conversion_window_seconds: z.int().nonnegative(),
    // null: 126_079 (99.63%)
    // format integer: 290 (61.44%)
    description: z.string().nullable(),
    // null: 114_520 (90.49%)
    // true 7_359 (61.17%), false 4_672 (38.83%)
    disable_experiment_input: z.boolean().nullable(),
    // null: 114_393 (90.39%)
    experiment_conversion_index: z.int().min(0).max(5).nullable(),
    // null: 119_192 (94.18%)
    // avg: 1737017892.47, min: 1662068042, max: 1834830147
    experiment_end_timestamp: z.int().nonnegative().nullable(),
    // null: 114_520 (90.49%)
    // true 6_930 (57.60%), false 5_101 (42.40%)
    experiment_finished: z.boolean().nullable(),
    experiment_splits: z.array(
      z.object({
        // true 12_346 (4.18%), false 283_199 (95.82%)
        does_control_exit: z.boolean(),
        // format object-id: 295_544 (100.00%)
        id: z.string(),
        // true 31_818 (10.77%), false 263_727 (89.23%)
        is_control: z.boolean(),
        // true 5_755 (1.95%), false 289_790 (98.05%)
        is_holdout: z.boolean(),
        name: z.string(),
        // null: 20_968 (7.09%)
        next_step_id: common.objectId.nullable(),
        // avg: 42.81, min: 0, max: 100
        percent: z.int().min(0).max(100),
      })
    ),
    // null: 119_192 (94.18%)
    // avg: 1736265871.35, min: 1661981642, max: 1749544787
    experiment_start_timestamp: z.int().nonnegative().nullable(),
    // null: 114_393 (90.39%)
    // avg: 2201868.25, min: 60, max: 8640000000
    experiment_window_seconds: z.int().nonnegative().nullable(),
    // null: 42 (0.03%)
    // true 2_259 (1.79%), false 124_250 (98.21%)
    is_personalized: z.boolean().nullable(),
    // null: 3 (0.00%)
    // true 11_749 (9.28%), false 114_799 (90.72%)
    is_randomized: z.boolean().nullable(),
    // null: 114_520 (90.49%)
    // true 11_488 (95.49%), false 543 (4.51%)
    send_best_path_if_insignificant: z.boolean().nullable(),
    // null: 126_494 (99.95%)
    training_result: z
      .object({
        completed: z.literal(true),
        // true 10 (17.54%), false 47 (82.46%)
        custom_events_used: z.boolean(),
        feature_winners: z.object({
          // undefined: 11 (19.30%), defined 46 (80.70%)
          recency: z
            .array(
              z.object({
                feature: z.string(),
                variant_id: common.objectId,
              })
            )
            .length(5)
            .optional(),
          // undefined: 22 (38.60%), defined 35 (61.40%)
          tenure: z
            .array(
              z.object({
                feature: z.string(),
                // null: 35 (20.00%)
                variant_id: common.objectId.nullable(),
              })
            )
            .length(5)
            .optional(),
        }),
        // avg: 1731907127.56, min: 1693580742, max: 1749393676
        finished_at: z.int().nonnegative(),
        // avg: 0.26, min: 0.01146, max: 1.06683
        projected_lift: z.number().nonnegative(),
        top_events: z.record(
          common.objectId,
          z.array(
            z.object({
              // avg: 0.48, min: -6.544119231097012, max: 14.812202026496081
              impact: z.number(),
              name: z.string(),
            })
          )
        ),
        // avg: 1731907745.88, min: 1693580742, max: 1749394888
        used_at: z.int().nonnegative(),
      })
      .nullable(),
    // true 57 (0.05%), false 126_494 (99.95%)
    training_success: z.boolean(),
    // null: 120_166 (94.95%)
    winning_experiment_split_id: common.objectId.nullable(),
  }),
});
